import { useCallback, useEffect, useState } from 'react';
import useAuthContext from '../../../../contexts/AuthContext';
import useErrorMessage from '../../../../utils/ErrorMessage';
import useEventFields from './eventFields';
import useWhatWhyFields from './whatWhyFields';
import usePriorFields from './priorFields';
import useContextFields from './contextFields';
import useUtilityFields from './utilityFields';
import useCostFields from './costFields';
import useActorFields from './actorsFields';
import usePlaningFields from './planingFields';
import useFederationFields from './federationFields';
import usePlanComFields from './planComFields';
import useRisksFields from './risksFields';
import useNoteFields from './noteFields';

const useFields = (title, id) => {
  const { message } = useErrorMessage();
  const [enums, setEnums] = useState();
  const [actors, setActors] = useState();
  const [isFieldsLoading, setIsFieldsLoading] = useState(true);
  const { eventFields } = useEventFields(enums || null, isFieldsLoading);
  const { whatWhyFields } = useWhatWhyFields();
  const { priorFields } = usePriorFields(enums || null, isFieldsLoading);
  const { contextFields } = useContextFields(enums || null, isFieldsLoading);
  const { utilityFields } = useUtilityFields(
    id,
    enums || null,
    isFieldsLoading,
    actors
  );
  const { costFields } = useCostFields(enums || null, isFieldsLoading);
  const { actorFields } = useActorFields(enums || null, isFieldsLoading);
  const { planingFields } = usePlaningFields();
  const { federationFields } = useFederationFields(
    enums || null,
    isFieldsLoading
  );
  const { planComFields } = usePlanComFields(
    id,
    enums || null,
    isFieldsLoading,
    actors
  );
  const { risksFields } = useRisksFields(id, enums || null, isFieldsLoading);
  const { noteFields } = useNoteFields();
  const { dispatchAPI } = useAuthContext();

  const fields = {
    event: eventFields,
    what: whatWhyFields,
    why: whatWhyFields,
    studies: priorFields,
    factors: contextFields,
    deliverables: utilityFields,
    costs: costFields,
    actors_list: actorFields,
    lifeProject: planingFields,
    membership: federationFields,
    deliverables_plan_com: planComFields,
    risk_list: risksFields,
    note: noteFields
  };

  const getEnums = async () => {
    try {
      const { data } = await dispatchAPI('GET', { url: '/projects/enums' });
      setEnums(data);
    } catch (e) {
      if (e.response) message(e.response.status);
    }
  };
  const getActors = async () => {
    try {
      const { data } = await dispatchAPI('GET', {
        url: `/projects/${id}?fields=actors.actors_list`
      });
      setActors(data.actors);
    } catch (e) {
      if (e.response) message(e.response.status);
    }
  };
  const getSelectOptions = useCallback(async () => {
    setIsFieldsLoading(true);
    await getEnums();
    if (id) await getActors();
    setIsFieldsLoading(false);
  }, []);

  useEffect(() => {
    (async () => {
      await getSelectOptions();
    })();
  }, [getSelectOptions]);

  return fields[title];
};

export default useFields;
